import React from "react";
import shortid from "shortid";
import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

import LineBreak from "@components/Global/Custom/Icons/LineBreak";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const WebsiteFAQ = () => {
	const classes = useStyles("Website");

	const backgroundColor = ""; // #ffebe5
	const backgroundGradient = ``; // for testing  linear-gradient(121.04deg,#79dfff 15.69%,#865cff)
	const backgroundImage = ``; // for testing https://wallpapercave.com/wp/wp8377155.jpg
	const coloredBox = false;

	const header = `Frequently asked questions`;
	const subHeader = ``;
	const tagline = "";
	const textAlign = "center"; // left / center / right
	const lineBreak = true;
	const content = "";

	// const button = "x";
	// const buttonLink = "/wesbite/about-us";

	// const buttonSecondary = "";
	// const buttonSecondaryLink = "/wesbite/about-us";

	const items = [
		{
			question: "How much does drain cleaning cost?",
			answer:
				"Roto-Rooter will provide a free estimate at no cost to you after expertly assessing and providing options to resolve your sewer & drain issue. We will offer an honest, upfront price without hidden fees or unnecessary upselling, and we will give you a written no-hassle guarantee.",
		},
		{
			question:
				"What are Roto-Rooter's hours of operation, and are they open on Saturdays and Sundays?",
			answer:
				"Roto-Rooter provides 24/7 service on Saturdays and Sundays. Call 512-258-3008 or schedule service online via our website.",
		},
		{
			question: "Does Roto-Rooter in Austin have any coupons or discounts?",
			answer:
				"Yes, Roto-Rooter in Austin offers a variety of coupons for both plumbing and drain service. Visit the coupons section of our website.",
		},
		{
			question:
				"What drain cleaning and plumbing services does Roto-Rooter in Austin provide?",
			answer: (
				<React.Fragment>
					<p>
						Roto-Rooter in Austin provides plumbing, drain cleaning, and water
						cleanup services 24 hours a day, 365 days a year. From emergency
						drain cleaning services to water and sewage removal services to
						plumbing services, we have you covered. Trusted since 1935,
						Roto-Rooter experts can help day or night.
					</p>
					<ul>
						<li>sewer mainline cleaning</li>
						<li>drain cleaning</li>
						<li>plumbing</li>
						<li>water heater repair & installation</li>
						<li>clogged drains</li>
						<li>sewer line inspections</li>
						<li>repairing burst pipes</li>
						<li>sump pump repair & installation</li>
						<li>bathroom and kitchen plumbing repair & installation</li>
					</ul>
				</React.Fragment>
			),
		},
	];

	return (
		<React.Fragment>
			<section
				className={
					tagline || header || subHeader || lineBreak || content
						? "websiteComponent"
						: "websiteComponent thin"
				}
				style={{
					backgroundColor:
						!coloredBox && backgroundColor ? backgroundColor : "unset",
					backgroundImage:
						!coloredBox && backgroundGradient ? backgroundGradient : "unset",
				}}
			>
				{backgroundImage && (
					<Box
						position={"absolute"}
						top={0}
						bottom={0}
						width={"100%"}
						style={{
							backgroundImage: `url(${backgroundImage})`,
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							backgroundPosition: "50% 50%",
							opacity: "0.4",
							//filter: "blur(2px)",
						}}
						zIndex={1}
					/>
				)}

				<Container maxWidth={"lg"} disableGutters style={{ zIndex: 3 }}>
					<div
						className={coloredBox ? classes.featuredTextBox : undefined}
						style={{
							backgroundColor:
								coloredBox && backgroundColor ? backgroundColor : "",
							backgroundImage:
								coloredBox && backgroundGradient ? backgroundGradient : "unset",
						}}
					>
						<Grid
							container
							spacing={8}
							justifyContent="center"
							alignItems={textAlign}
						>
							<Grid item xs={12}>
								<Box
									display={"flex"}
									flexDirection={"column"}
									justifyContent={"center"}
									alignItems={textAlign}
									height={"100%"}
								>
									{tagline && (
										<Box className="tagline" textAlign={textAlign}>
											{tagline}
										</Box>
									)}

									{header && (
										<Box component={"h2"} textAlign={textAlign}>
											{header}
										</Box>
									)}

									{subHeader && (
										<Box component={"h3"} textAlign={textAlign}>
											{subHeader}
										</Box>
									)}

									{lineBreak && (
										<Box my={1} textAlign={textAlign}>
											<LineBreak className={classes.lineBreak} />
										</Box>
									)}

									{content && (
										<>
											<Box component={"p"} textAlign={textAlign}>
												{content}
											</Box>
										</>
									)}

									<Box my={6}>
										{items.map((item) => (
											<Accordion
												classes={{ root: classes.accordionRoot }}
												key={shortid.generate()}
											>
												<AccordionSummary
													expandIcon={
														<ExpandMoreIcon className={classes.faqExpandIcon} />
													}
													//aria-controls={shortid.generate()}
													//id={shortid.generate()}
													classes={{
														root: classes.accordionSRoot,
														content: classes.accordionSContent,
													}}
												>
													<div className={classes.faqQuestion}>
														{item.question}
													</div>
												</AccordionSummary>
												<AccordionDetails
													classes={{ root: classes.accordionDetailsRoot }}
												>
													<div className={classes.faqAnswer}>
														<div
															dangerouslySetInnerHTML={{
																__html: item.answer,
															}}
														/>
													</div>
												</AccordionDetails>
											</Accordion>
										))}
									</Box>

									{/* <Box className={classes.columnButtonsBox} textAlign={textAlign}>
									{button && (
										<Button
											size="large"
											color="primary"
											variant="contained"
											disableElevation
											href={buttonLink}
										>
											{button}
										</Button>
									)}

									{buttonSecondary && (
										<Button
											size="large"
											color="secondary"
											variant="outlined"
											disableElevation
											href={buttonSecondaryLink}
										>
											{buttonSecondary}
										</Button>
									)}
								</Box> */}
								</Box>
							</Grid>
						</Grid>
					</div>
				</Container>
			</section>
		</React.Fragment>
	);
};

export default WebsiteFAQ;
